import React, { useState, useEffect } from 'react';

interface TypingEffectProps {
  text: string;
  delay?: number;
  onComplete?: () => void;
  onProgress?: () => void;
}

const TypingEffect: React.FC<TypingEffectProps> = ({ 
  text, 
  delay = 5,
  onComplete,
  onProgress
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    // Reset when text changes
    setDisplayedText('');
    setCurrentIndex(0);
    setIsComplete(false);
  }, [text]);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + text[currentIndex]);
        setCurrentIndex(prevIndex => prevIndex + 1);
        
        // Call onProgress callback every few characters to help with scrolling
        if (onProgress && currentIndex % 10 === 0) {
          onProgress();
        }
      }, delay);
      
      return () => clearTimeout(timeout);
    } else if (!isComplete) {
      setIsComplete(true);
      if (onComplete) {
        onComplete();
      }
    }
  }, [currentIndex, delay, text, isComplete, onComplete, onProgress]);

  return (
    <span className="whitespace-pre-line">
      {displayedText}
      {currentIndex < text.length && (
        <span className="typing-cursor">|</span>
      )}
    </span>
  );
};

export default TypingEffect;
